export const routes = {
  customer: "/customer-old",
  v2customer: "/customer",
  partner: "/partner",
  emailSuccess: "/email-success",
  emailFailed: "/email-failed",
  sberIdCallback: "/idp/sber-customer/callback"
};
